import TransferOrderManagement from './TransferOrderManagement.vue'

export default TransferOrderManagement



// WEBPACK FOOTER //
// ./src/pages/salesManagement/transferOrder/index.js